import * as React from "react";
import { forwardRef } from "react";
const SvgChat = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.2222 13.9833H11.4691L11.6678 14.13L16.25 17.5138L16.25 3.75L1.75 3.75L1.75 13.9833H11.2222Z", stroke: "currentcolor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgChat);
export default ForwardRef;
